import React from 'react';
import Section from '../components/common/Section';
import { Helmet } from 'react-helmet-async';

const RefundPolicy = () => {
    return (
        <>
            <Helmet>
                <title>Cancellation & Refund Policy | PyrusMedia</title>
                <meta name="description" content="Cancellation & Refund Policy for PyrusMedia" />
            </Helmet>
            <Section className="bg-white pt-32 pb-20">
                <div className="max-w-4xl mx-auto text-gray-600">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">Cancellation & Refund Policy</h1>

                    <div className="space-y-8">
                        <section>
                            <p className="leading-relaxed mb-4">
                                Pyrus Media believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
                            </p>
                            <p className="leading-relaxed mb-4">
                                Cancellations will be considered only if the request is made within 1-2 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
                            </p>
                            <p className="leading-relaxed mb-4">
                                Pyrus Media does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.
                            </p>
                            <p className="leading-relaxed mb-4">
                                In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 1-2 days of receipt of the products.
                            </p>
                            <p className="leading-relaxed mb-4">
                                In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 1-2 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.
                            </p>
                            <p className="leading-relaxed mb-4">
                                In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.
                            </p>
                            <p className="leading-relaxed">
                                In case of any Refunds approved by the Pyrus Media, it’ll take 3-5 days for the refund to be processed to the end customer.
                            </p>
                        </section>
                    </div>
                </div>
            </Section>
        </>
    );
};

export default RefundPolicy;
